import React from "react";
import { NavLink, Outlet } from "react-router-dom";

function CommonContainer({ SUBNAV, children, DISABLED, MAINTITLE }: any) {
  return (
    <div className="w-full rounded-lg space-y-3">
      {!DISABLED && (
        <header className="w-full p-2 md:p-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 min-h-8 sm:min-h-0 shadow-[rgba(99,99,99,0.15)_0px_1px_4px_0px] dark:shadow-slate-900/50 rounded-md transition-colors duration-300 bg-white dark:bg-slate-800 dark:border dark:border-slate-700">
          <div className="flex flex-col sm:flex-row items-start sm:items-center w-full gap-2 sm:gap-3">
            {MAINTITLE && (
              <h3 className="font-semibold text-xs sm:text-sm leading-[1.27] font-inter whitespace-nowrap capitalize flex-shrink-0 transition-colors duration-300 text-slate-600 dark:text-slate-300">
                {MAINTITLE}
              </h3>
            )}
            {children && (
              <div className="w-full sm:w-auto">
                {children}
              </div>
            )}
            <div className="flex justify-start sm:justify-end w-full sm:w-auto sm:ml-auto gap-1 sm:gap-1.5 overflow-x-auto scrollbar-hide -mx-2 sm:mx-0 px-2 sm:px-0">
              {SUBNAV
                ? SUBNAV?.map((ITEM: any, i: number) => {
                    if (!ITEM.DISABLED) {
                      return (
                        <NavLink
                          key={i}
                          to={ITEM.PATH}
                          end={!ITEM.SUBNAV?.length}
                          className={({ isActive }) =>
                            `inline-flex items-center justify-center relative box-border cursor-pointer select-none align-middle appearance-none font-['Public_Sans',sans-serif] text-[10px] sm:text-xs leading-[1.25] min-w-[48px] sm:min-w-[56px] font-medium outline-0 rounded-lg px-2.5 py-1.5 sm:px-3 sm:py-2 transition-all duration-300 ease-in-out whitespace-nowrap flex-shrink-0 ${
                              isActive
                                ? "border border-solid border-primary/30 text-primary bg-primary/10 shadow-sm dark:text-primaryLight dark:bg-primary/20"
                                : "border border-transparent text-slate-500 hover:text-primary hover:bg-primary/5 hover:border-primary/20 dark:text-slate-400 dark:hover:text-primaryLight dark:hover:bg-slate-700/50 dark:hover:border-slate-600 active:scale-95"
                            }`
                          }
                        >
                          {ITEM.TITLE}
                        </NavLink>
                      );
                    }
                    return null;
                  })
                : null}
            </div>
          </div>
        </header>
      )}
      <div className="w-full h-full transition-colors duration-300">
        <Outlet />
      </div>
    </div>
  );
}

export default CommonContainer;
